import ApplicationController from './application_controller'

// This controller adds simple text filtering by looking for the
// searchInput text inside each listSearchItemTarget.querySelector(this.itemSelectorValue) element.
// 
// - non-matches have d-none added
// -     matches have d-none removed
//
// it also provides a selectFirstVisibleItem() action to add
// easy enter-key navigation when selection is complete
export default class extends ApplicationController {

	static values = {
		itemSelector: { type: String, default: '.item-name' }
	}

	static targets = [
		'searchInput',
		'item',
	]

	static outlets = [
		'section-empty',
		'item-counter'
	]

	searchList(_event) {
		const elements   = this.itemTargets
		const searchText = this.searchInputTarget.value ? this.searchInputTarget.value.toUpperCase() : null

		if (!searchText) {
			this.displayAllElements(elements)
		} else {
			this.filterElementsBySearch(elements, searchText)
		}

		this.sectionEmptyOutlets.forEach(outlet => outlet.itemsChanged())
		this.itemCounterOutlets.forEach(outlet => outlet.updateItemCounter())
	}

	filterElementsBySearch(elements, searchText) {
		for (let element of elements) {
			const itemName = element.querySelector(this.itemSelectorValue).innerText.toUpperCase()
			if (itemName.indexOf(searchText) == -1) {
				element.classList.add('d-none')
			} else {
				element.classList.remove('d-none')
			}
		}
	}

	displayAllElements(elementArray) {
		for (let element of elementArray) {
			element.classList.remove('d-none')
		}
	}

	selectFirstVisibleItem(event) {
		event.preventDefault()
		const firstVisibleItem = this.itemTargets.find( (item) => !item.classList.contains('d-none') )
		if (firstVisibleItem.tagName == 'A') {
			firstVisibleItem.click()
		} else {
			const input = firstVisibleItem.querySelector('input')

			if (!input.disabled) { input.checked = true }

			this.dispatch('selectionChanged')
		}
	}

	reset(_event) {
		if (!this.hasSearchInputTarget) { return }
		this.searchInputTarget.value = ''
		this.searchList()
	}

	submitForm(_event) { this.element.closest('form').requestSubmit() }

}
